import type { ReactNode } from "react";
import { useLocation } from "wouter";
import {
  isCustomerShopOrAccountPath,
  isPublicMarketingOrMarketPath,
} from "@/lib/app-surface";

/**
 * Keep customer shop/account routes outside the operator auth and data
 * providers. The customer session is owned by PortalAuthProvider, not Clerk.
 * Public marketing and market pages also get their own minimal provider tree.
 */
export function AppSurfaceBoundary({
  customerSurface,
  publicSurface,
  staffSurface,
}: {
  customerSurface: ReactNode;
  publicSurface: ReactNode;
  staffSurface: ReactNode;
}) {
  const [pathname] = useLocation();
  if (isCustomerShopOrAccountPath(pathname)) return customerSurface;
  if (isPublicMarketingOrMarketPath(pathname)) return publicSurface;
  return staffSurface;
}